import { HttpEventType } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, viewChild, effect, signal, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { Fichier } from '../../bo/fichier';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';

@Component({
  selector: 'app-site-template-sheet-config',
  templateUrl: './site-template-sheet-config.component.html',
  styleUrls: ['./site-template-sheet-config.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteTemplateSheetConfigComponent {

  tabFichiers = signal<Fichier[]>([]);
  proprietesAfficheesTemplates: ProprieteAffichee[] = [];
  erreurRecuperation = signal(false);
  private readonly fileToDelete = signal<Fichier | null>(null);
  private readonly isIE: boolean;

  readonly modalSuppr = viewChild<ModalDirective>('modalSuppr');

  constructor(private readonly http: HttpService, private readonly fonctionsService: FonctionsService, private readonly translate: TranslateService,
    private readonly userService: UtilisateurService) {
    if (navigator.userAgent.match(/Edge/i) || navigator.userAgent.match(/Trident.*rv[ :]*11\./i)) {
      this.isIE = true;
    }
    else {
      this.isIE = false;
    }
    this.proprietesAfficheesTemplates = new Fichier().getProprietesAffichees();
    effect(() => { this.userService.currentSite(); this.refresh(); });
  }


  refresh() {
    this.erreurRecuperation.set(false);

    var startLoader = setTimeout(() => {
      this.fonctionsService.loading_screen(true);
    }, 300);

    this.http.get<Fichier[]>('Sites/' + this.userService.currentSite()?.siteId + '/Templates').subscribe(resultat => {
      this.tabFichiers.set(resultat);
      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
    }, () => {
      this.erreurRecuperation.set(true);
      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
    });
  }

  fileFromInput(event) {
    this.uploadFile(event.srcElement.files);
  }

  private uploadFile(files: File[]) {

    if (files.length == 0) return;

    const frmData = new FormData();
    for (var i = 0; i < files.length; i++) {
      let filename = files[i].name;
      if (this.isIE) {
        let arrFilename = files[i].name.split("\\");
        filename = arrFilename[arrFilename.length - 1];
      }
      frmData.append(filename, files[i]);
    }

    this.http.request('POST', 'Sites/' + this.userService.currentSite()?.siteId + '/Template', frmData).subscribe(
      event => {
        if (event.type === HttpEventType.Response) {
          this.refresh();
          this.fonctionsService.launch_toast(true);
        }
      },
      (err: any) => {
        this.erreurRecuperation.set(true);
        this.fonctionsService.launch_toast(false);
      }
    );
  }


  hideConfirmSuppr() {
    this.fileToDelete.set(null);
    this.modalSuppr()?.hide();
  }
  showConfirmSuppr(file: Fichier) {
    this.fileToDelete.set(file);
    this.modalSuppr()?.show();
  }



  delete() {
    this.modalSuppr()?.hide();
    this.fonctionsService.loading_screen(true);
    if (null != this.fileToDelete()) {
      this.http.delete<boolean>('Sites/' + this.userService.currentSite()?.siteId + '/Template/' +
        this.fileToDelete().fichierId).subscribe(resultat => {
          this.refresh();
          this.fonctionsService.loading_screen(false);
          this.fonctionsService.launch_toast(true);
        }, () => {
          this.fonctionsService.loading_screen(false);
          this.fonctionsService.launch_toast(false);
        });
    }
  }
}
